import React, { useCallback } from "react";
import { ASSESSMENT_SUBJECT_SELF } from "components/Assessment/Subject";
import { useTranslation } from "react-i18next";

export function AssessmentAge({
  assessmentSubject,
  defaultValue = null,
  className = "",
  onAnswer = () => {},
  onNext = () => {},
}) {
  const { t } = useTranslation();
  const inputLoaded = useCallback((inputElement) => {
    if (inputElement) {
      inputElement.focus();
    }
  }, []);
  if (defaultValue === null || Number.isNaN(defaultValue)) {
    defaultValue = '';
  }
  return (
    <div>
      <div className={className}>{ t(
        (assessmentSubject.value === ASSESSMENT_SUBJECT_SELF)
          ? 'please enter your age'
          : 'please enter the age of the assessment subject'
      ) }</div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onAnswer(parseInt(e.target.age.value, 10));
          onNext(); // signal to parent component that this question is done
        }}
      >
        <input
          name="age"
          type="number"
          ref={inputLoaded}
          onChange={(e) => (onAnswer(parseInt(e.target.value, 10)))}
          onKeyDown={(e) => (onAnswer(parseInt(e.target.value, 10)))}
          defaultValue={defaultValue}
        />
      </form>
    </div>
  )
}